<template>
  <div
    v-if="!isGiftAlreadyAdded && areGiftConditionsMet"
    class="rounded-md border"
  >
    <div
      class="flex justify-between rounded-t-md px-4 py-2"
      :style="promotionStyle"
    >
      <Headline size="xs">
        {{ $t('basket.promotion.choose_free_gift') }}
      </Headline>
      <PromotionCountdown
        v-if="giftPromotion"
        :until="giftPromotion.schedule.to"
        borderless
      />
    </div>
    <div class="p-4">
      <BasketPromotionGiftsSlider v-bind="{ basketItem, products }" />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ basketItem: FimBasketItem }>()

const basketItem = computed(() => props.basketItem)

const { giftPromotion, promotionStyle, areGiftConditionsMet } =
  await useBasketItemPromotion(basketItem)

const { products, isGiftAlreadyAdded } = await usePromotionGifts(
  props.basketItem.product,
)
</script>
